<template>
  <div id="footer" class="footer">
    <p>{{ $t('footer') }}</p>
    <span class="navbar-version">{{ version }}</span>
  </div>
</template>

<script lang="ts" src="./jhi-footer.component.ts"></script>
